import React, { useState, useEffect } from "react"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import apiClient from "../../api/apiClient"
const getItemStyle = (isDragging, draggableStyle) => ({
  // Change background color if dragging
  background: isDragging ? "#f8f9fa" : "white",

  // Apply the draggable style
  ...draggableStyle,

  // Ensure the dragged item maintains its full width and spacing
  display: "table-row",
  width: "50%",
  margin: "0",
  padding: "0",

  // Prevent the dragged item from collapsing
  boxSizing: "border-box"
})

const CategoryManager = ({ type }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  // Determine the date field based on type
  const dateField = type === "UI" ? "sort_date_ui" : "sort_date_report";

  // Fetch categories from API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiClient.get(`/report/category`);
        const sortedCategories = response.data.results.sort(
          (a, b) => new Date(a[dateField]) - new Date(b[dateField])
        );
        setCategories(sortedCategories);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setLoading(false);
      }
    };

    fetchCategories();
  }, [dateField]);

  // Handle drag end
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(categories);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setCategories(items);
  };

  // Save new order to backend
  const saveOrder = async () => {
    setIsSaving(true);
    try {
      const updatedCategories = categories.map((cat, index) => ({
        ...cat,
        [dateField]: new Date(Date.now() - (categories.length - index) * 86400000).toISOString()
      }));

      await apiClient.put(`/report/category/reorder`, {
        categories: updatedCategories,
        type: type === "UI" ? "UI" : "pdf" // Send appropriate type to backend
      });
      
      setCategories(updatedCategories);
      alert("Order saved successfully!");
    } catch (error) {
      console.error("Error saving order:", error);
      alert("Failed to save order");
    } finally {
      setIsSaving(false);
    }
  };

  // Style for draggable items
  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    background: isDragging ? 'lightgreen' : 'white',
    ...draggableStyle,
  });

  return (
    <div className="container mt-4">
      <h2>
        {type === "UI" ? "Manage Categories (UI Manager)" : "Manage Categories (PDF)"}
      </h2>
      <p>Drag and drop to reorder categories</p>

      {loading ? (
        <div>Loading categories...</div>
      ) : (
        <>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="categories">
              {(provided) => (
                <div 
                  className="table-responsive" 
                  {...provided.droppableProps} 
                  ref={provided.innerRef}
                >
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Position</th>
                        <th>Category Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {categories.map((category, index) => (
                        <Draggable 
                          key={category._id} 
                          draggableId={category._id} 
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              <td>{index + 1}</td>
                              <td>{category.name}</td>
                       
                            </tr>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </tbody>
                  </table>
                </div>
              )}
            </Droppable>
          </DragDropContext>

          <div className="mt-3">
            <button 
              className="btn btn_bg_secondery" 
              onClick={saveOrder} 
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save Order"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};


export default CategoryManager
